const addAdvertsIntoPositions = (
  productCollection,
  productsWithAdverts,
  isFirstProductAnAdvert,
  adsConfig
) => {
  if (!productCollection?.length || !productsWithAdverts?.length)
    return productCollection || [];
  const productsReArranged = [];
  const repositionedProductsNoAds = [];

  const { advertPositions, advertPositionsSecondary } = adsConfig;
  const advertPositioning = isFirstProductAnAdvert
    ? advertPositions
    : advertPositionsSecondary;
  const reducingProductsWithAdverts = [...productsWithAdverts];

  productCollection.forEach((productItem, index) => {
    const hasAdPosition = advertPositioning.includes(index);

    const hasFoundProductInBoth = isProductInBoth(
      productsWithAdverts,
      productItem
    );

    if (hasAdPosition && reducingProductsWithAdverts.length !== 0) {
      const productItemWithAdvert = reducingProductsWithAdverts.shift();

      productsReArranged.push(productItemWithAdvert);

      if (!hasFoundProductInBoth) {
        repositionedProductsNoAds.push(productItem);
      }
    } else {
      const isProductFound = isProductInNewReArranged(
        productsReArranged,
        productItem
      );
      if (!isProductFound) {
        productsReArranged.push(productItem);
      }
    }
  });

  return [...productsReArranged, ...repositionedProductsNoAds];
};

const isProductInBoth = (productsWithAdverts, productItem) =>
  productsWithAdverts.find(
    (productWithAdvert) => productWithAdvert.productId === productItem.productId
  );

const isProductInNewReArranged = (productsReArranged, product) =>
  productsReArranged.find(
    (productItem) => productItem.productId === product.productId
  );

export default addAdvertsIntoPositions;
